import { ArrowRightOutlined } from '@ant-design/icons'
import { createLink } from '@tanstack/react-router'
import { Button, Card, Flex } from 'antd'
import type { LinkView } from 'features/libra/dashboard/ticketDashboard/types'
import type { FC, ReactNode } from 'react'

export const LinkButton = createLink(Button)

interface LinkRowProps {
  link: LinkView | undefined
  children: ReactNode
}

/** A boxed row, e.g. a comment thread or an earlier version, with a button that opens it. */
export const LinkRow: FC<LinkRowProps> = ({ link, children }) => (
  <Card size='small'>
    <Flex justify='space-between' align='center' gap='small'>
      {children}
      {link && (
        <LinkButton
          size='small'
          icon={<ArrowRightOutlined />}
          iconPlacement='end'
          to={link.to}
          search={link.search}>
          {link.label}
        </LinkButton>
      )}
    </Flex>
  </Card>
)
